import { ReactNode } from 'react';

import {
    Alignable,
    Button,
    ButtonVariant,
    Column,
    Columns,
    Text,
    TextLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

import { UserType } from '@app-types/user';

import { BigIcon } from '@components/big';

import { paths } from '@helpers/path';

export interface NoProposedLinesProps {
    user: UserType;
    title?: ReactNode;
    description?: ReactNode;
    cta?: {
        label: string;
        href: string;
    } | null;
}

export function NoProposedLines({
    user,
    title = (
        <>
            <span className='is-capitalized'>{user.given_name.toLowerCase()}</span>, vous pouvez faire des <BigIcon />{' '}
            economies&nbsp;!
        </>
    ),
    description = 'Souscrivez une Bbox avec un forfait et économisez sur vos offres internet et mobile.',
    cta = { label: 'Choisir un pack Bbox + forfait', href: paths.promos },
}: Readonly<NoProposedLinesProps>) {
    return (
        <Columns verticalAlign={Alignable.ALIGNED_CENTER} multiline align={Alignable.ALIGNED_CENTER}>
            <Column className='has-text-centered-mobile'>
                <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    {title}
                </Text>
                {description && (
                    <Text level={TextLevels.TWO} marginless>
                        {description}
                    </Text>
                )}
            </Column>
            <Column narrow>
                <Button
                    markup='a'
                    href={cta?.href}
                    variant={ButtonVariant.PRIMARY}
                    data-cy='view-mobile-contracts-button'
                >
                    {cta?.label}
                </Button>
            </Column>
        </Columns>
    );
}
